
let response = {
    "result": 1,
    "msg": "",
    "data": {
        "surveyInfo": {
            "id": 1,
            "name": "测试01",
            "slug": "8Pd7SQcrHO",
            "category": "Robot Vacuums"
        },
        "questionList": [
            {
                "id": 1,
                "questionText": "What do you want most for your robot vacuum?",
                "surveyId": 1,
                "type": "radio",
                "sort": 1,
                "score": 10,
                "answerList": [
                    {
                        "questionId": 1,
                        "answerTitle": "Cutting-Edge Technology",
                        "sort": 1
                    },
                    {
                        "questionId": 1,
                        "answerTitle": "Deep and Thorough Cleaning",
                        "sort": 2
                    },
                    {
                        "questionId": 1,
                        "answerTitle": "Essential and Reliable Cleaning",
                        "sort": 3
                    },
                    {
                        "questionId": 1,
                        "answerTitle": "Cost-Effective and Value-Driven",
                        "sort": 4
                    }
                ]
            },
            {
                "id": 2,
                "questionText": "Do you often have obstacles like charging cables, slippers, or socks on the floor?",
                "surveyId": 1,
                "type": "radio",
                "sort": 2,
                "score": 10,
                "answerList": [
                    {
                        "questionId": 2,
                        "answerTitle": "Yes",
                        "sort": 1
                    },
                    {
                        "questionId": 2,
                        "answerTitle": "No",
                        "sort": 2
                    },
                    {
                        "questionId": 2,
                        "answerTitle": "Sometimes",
                        "sort": 3
                    },
                    {
                        "questionId": 2,
                        "answerTitle": "I don't know",
                        "sort": 4
                    }
                ]
            },
            {
                "id": 3,
                "questionText": "How would you like to use your robot vacuum? Select all that apply.",
                "surveyId": 1,
                "type": "checkbox",
                "sort": 3,
                "score": 10,
                "answerList": [
                    {
                        "questionId": 3,
                        "answerTitle": "Pet Hair and Hair Cleaning",
                        "sort": 1
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Hands-Free Maintenance",
                        "sort": 2
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Clean Under Very Low Furnitures",
                        "sort": 3
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Cross Thresholds to Clean More Rooms",
                        "sort": 4
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Auto Water Refill & Drainage (Plumbing)",
                        "sort": 5
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Voice Control & Smart Home",
                        "sort": 6
                    },
                    {
                        "questionId": 3,
                        "answerTitle": "Edge Cleaning and Mopping",
                        "sort": 7
                    }
                ]
            }
        ]
    }
};
// document.addEventListener('DOMContentLoaded', function() {
//     const SubmitData = {
//         userId: 123,  
//         type: 'new', 
//     };

//     getQuestion(SubmitData)
//     .then((data) => {
//         renderQuestion(data);
//     })
//     .catch((error) => {
//         console.error('获取数据失败', error);
//     });
// });
// function getQuestion(){
//     return axios({
//         method: 'GET',
//         url: '/a/res/coupon/get',
//         params: SubmitData, 
//     })
//     .then((res) => {
//         if (res.data.result === 1) {
//             return res.data;  
//         } else {
//             throw new Error('请求返回结果不符合预期');
//         }
//     })
//     .catch((error) => {
//         console.error('请求出错:', error);
//         throw error; 
//     });
// }
function renderQuestion(data) {
    const swiperWrapper = document.querySelector('.swiper-wrapper');
    swiperWrapper.innerHTML = '';
    let slidesContent = '';

    data.questionList.forEach((item, questionIndex) => {
        let slideContent = `
            <div class="swiper-slide">
            <span class="question-type">${item.type}</span>
            <h2 class="question-title">${item.questionText}</h2>
            <div class="options-container">
        `;

        if (item.type === 'radio') {
            item.answerList.forEach((option, optionIndex) => {
                const uniqueId = `question-${questionIndex}-option-${optionIndex}`;
                slideContent += `
                    <div class="option-wrapper">
                    <input type="radio" name="question-${questionIndex}" id="${uniqueId}" value='${JSON.stringify({
                        ...item,
                        answerList: {
                            ...item.answerList,
                            option: {
                                ...item.answerList.option,
                                selected: option.sort
                            }
                        }
                    })}' style="display: none;" />
                    <label for="${uniqueId}" class="option-label">${option.answerTitle}</label>
                    </div>
                `;
            });
        } else if (item.type === 'checkbox') {
            item.answerList.forEach(option => {
                slideContent += `
                    <div class="option-wrapper">
                    <input type="checkbox" name="question-${item.title}" id="option-${option.sort}" value="${JSON.stringify({
                        ...item,
                        answerList: {
                            ...item.answerList,
                            option: {
                                ...item.answerList.option,
                                selected: option.sort
                            }
                        }
                    })}" style="display: none;" />
                    <label for="option-${option.sort}" class="option-label">${option.answerTitle}</label>
                    </div>
                `;
            });
        }

        slideContent += `</div></div>`;
        slidesContent += slideContent;
    });

    console.log(slidesContent);
    swiperWrapper.innerHTML = slidesContent;

    const swiper = new Swiper('.swiper-container', {
        loop: false,
        autoHeight:true,
        allowTouchMove: false,
        slidesPerView: 1,
        spaceBetween: 10,
        autoplay: false,
        pagination: {
            el: '.swiper-pagination',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
                const progressBarWidth = (100 - ((total - 1) * 2)) / total;

                let html = '';
                for (let i = 0; i < total; i++) {
                    const isActive = i < current ? 'active' : '';
                    html += `
                        <span class="swiper-pagination-progressbar ${isActive}" style="width: ${progressBarWidth}%;"></span>`;
                }
                return html;
            },
        },
        navigation: {
            nextEl: '.custom-next',
            prevEl: '.custom-prev', 
            disabledClass: 'custom-disabled',
        },
        on: {
            init: function () {
                console.log('Swiper initialized');
                setTimeout(updateNextButtonState, 0);
            },
            slideChangeTransitionStart: function () {
                console.log('Slide is changing...');
            },
            slideChange: function () {
                updateNextButtonState();
            },
        }
    });

    function validateCurrentSlide() {
        console.log(swiper, swiper.activeIndex, swiper.slides);
        const currentSlide = swiper.slides[swiper.activeIndex];
        const inputs = currentSlide.querySelectorAll('input');
        let isValid = false;

        inputs.forEach((input) => {
            if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) {
                isValid = true;
            }
        });

        return isValid;
    }

    const nextButton = document.querySelector('.custom-next');

    function updateNextButtonState() {
        const isValid = validateCurrentSlide();
        if (isValid) {
            nextButton.classList.remove('disabled');
        } else {
            nextButton.classList.add('disabled');
        }
    }

    function bindInputEvents() {
        document.querySelectorAll('.option-wrapper input').forEach((input) => {
            const label = input.nextElementSibling;
            const inputName = input.name;

            input.addEventListener('change', () => {
                const allInputsInGroup = document.querySelectorAll(`input[name="${inputName}"]`);
                const allLabelsInGroup = Array.from(allInputsInGroup).map((input) => input.nextElementSibling);

                if (input.type === 'radio') {
                    allLabelsInGroup.forEach((label) => label.classList.remove('selected'));
                }

                if (input.checked) {
                    label.classList.add('selected');
                } else {
                    label.classList.remove('selected');
                }
                updateNextButtonState();
            });
        });
    }

    bindInputEvents();

    const originalSlideNext = swiper.slideNext;

    swiper.slideNext = function () {
        console.log('next go')
        if (nextButton.classList.contains('disabled')) {
            alert('请填写当前页的选项！');
            updateNextButtonState();
            return;
        }

        originalSlideNext.call(swiper);
    };

    nextButton.addEventListener('click', (event) => {
        event.preventDefault();
        //swiper.slideNext();
    });
}


renderQuestion(response.data)

// function getAnswer(data){

// }
